import { CircleCheckIcon, CircleIcon, Trash2Icon } from "@lucide/icons";

import { styled } from "simplydo/react/styled";
import { Icon } from "simplydo/react/ui/icon";
import { Label, LabelContent, LabelDetail } from "simplydo/react/ui/label";

import type { AssessmentRound } from "./types";

const SelectableWrapper = styled.span<{ $selected?: boolean }>`
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  cursor: pointer;
  border-radius: 4px;
  opacity: ${({ $selected }) => ($selected ? 1 : 0.85)};

  &:hover {
    opacity: 1;
  }
`;

const TruncatedName = styled(LabelContent)`
  max-width: 16rem;
  min-width: 0;
`;

export const RoundLabelsGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: flex-end;
`;

type AssessmentRoundLabelProps = {
  assessmentRound?: AssessmentRound;
  onDelete?: () => void;
  selectable?: boolean;
  selected?: boolean;
  onToggle?: () => void;
};

export const AssessmentRoundLabel = ({
  assessmentRound,
  onDelete,
  selectable,
  selected,
  onToggle,
}: AssessmentRoundLabelProps) => {
  const name = assessmentRound?.name || "Assessment";
  const label = (
    <Label size="small" color={selected ? "secondary" : "grey"}>
      <TruncatedName>{name}</TruncatedName>
      {selectable ? (
        <LabelDetail as="span">
          <Icon
            icon={selected ? CircleCheckIcon : CircleIcon}
            style={{ margin: 0 }}
          />
        </LabelDetail>
      ) : onDelete ? (
        <LabelDetail
          onClick={() => {
            onDelete();
          }}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              onDelete();
            }
          }}
        >
          <Icon icon={Trash2Icon} style={{ margin: 0 }} />
        </LabelDetail>
      ) : null}
    </Label>
  );

  if (selectable) {
    return (
      <SelectableWrapper
        $selected={selected}
        onClick={onToggle}
        role="button"
        aria-pressed={selected}
      >
        {label}
      </SelectableWrapper>
    );
  }

  return label;
};
